import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import TextField from "../../Form/TextField";
import CustomCard from "../../UI/CustomCard/CustomCard";
import CheckboxField from "../../Form/CheckboxField";
import { AlertInfo } from "../../UI/StandardAlerts/StandardAlerts";
import HiddenField from "../../Form/HiddenField";
export const getRuleSetRequest = (formState) => {
    return {
        id: formState.id,
        name: formState.name,
        active: formState.active,
        firstName: formState.firstName,
        lastName: formState.lastName,
        personalEmailAddress: formState.personalEmailAddress,
        birthDate: formState.birthDate,
        addressLine1: formState.addressLine1,
        city: formState.city,
        state: formState.state,
        zipCode: formState.zipCode,
    };
};
const RuleSetForm = () => {
    return (_jsxs(_Fragment, { children: [_jsx(HiddenField, { name: "id" }), _jsx(CustomCard, { title: "Details", className: "mb-3", children: _jsxs("div", { className: "card-body", children: [_jsx(TextField, { name: "name", label: "Name", required: true }), _jsx(CheckboxField, { name: "active", label: "Active" })] }) }), _jsx(CustomCard, { title: "Configuration", className: "mb-3", children: _jsxs("div", { className: "card-body", children: [_jsx(AlertInfo, { message: "This rule set will find persons that have duplicated information on ALL of the following checked fields" }), _jsx(CheckboxField, { name: "firstName", label: "First Name" }), _jsx(CheckboxField, { name: "lastName", label: "Last Name" }), _jsx(CheckboxField, { name: "personalEmailAddress", label: "Personal Email Address" }), _jsx(CheckboxField, { name: "birthDate", label: "Birthdate" }), _jsx(AlertInfo, { message: "Only addresses marked as current will be considered when detecting duplicates." }), _jsx(CheckboxField, { name: "addressLine1", label: "Address Line 1" }), _jsx(CheckboxField, { name: "city", label: "City" }), _jsx(CheckboxField, { name: "state", label: "State" }), _jsx(CheckboxField, { name: "zipCode", label: "Zip Code" })] }) })] }));
};
export default RuleSetForm;
